import { createApp } from 'vue'
import App from './App.vue'
import route from './router'
import { store } from "./store";
//配置Antd
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import Vant from 'vant';
import 'vant/lib/index.css'
import * as Icons from "@ant-design/icons-vue";


let app=createApp(App)
app.use(store)
app.use(route)
app.use(Antd)
app.use(Vant)
app.mount('#app')
for (const i in Icons) {
    app.component(i, Icons[i]);
}